import { useState, useEffect } from "react";

const useMountAnimation = (parentShow) => {
  const [showClassName, setShowClassName] = useState(false);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!parentShow) {
      setShowClassName(false);
    } else {
      setShow(true);
      setTimeout(() => setShowClassName(true), 10);
    }
  }, [parentShow]);

  const onTransitionEnd = () => !parentShow && setShow(false);

  return {
    show,
    showClassName,
    onTransitionEnd
  };
};

export default useMountAnimation;
